import { render, staticRenderFns } from "./o-product-details.vue?vue&type=template&id=273b3c19&scoped=true&"
import script from "./o-product-details.vue?vue&type=script&lang=js&"
export * from "./o-product-details.vue?vue&type=script&lang=js&"
import style0 from "./o-product-details.vue?vue&type=style&index=0&id=273b3c19&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "273b3c19",
  null
  
)

export default component.exports